import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatFlatAngled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuMjUxIDE0LjU0TDIxLjU2MSAxNi40M0w5LjIwMDk4IDExLjk2TDExLjI4MSA2LjI5OTk5TDE5Ljg0MSA5LjM4OTk5QzIxLjk0MSAxMC4xNSAyMy4wMjEgMTIuNDUgMjIuMjUxIDE0LjU0Wk0xLjUwMDk4IDEyLjM5TDguMDAwOTggMTQuNzNWMTkuMjVIMTYuMDAxVjE3LjYyTDIwLjUyMSAxOS4yNUwyMS4yMTEgMTcuMzZMMi4xOTA5OCAxMC41TDEuNTAwOTggMTIuMzlaTTcuMzAwOTggMTAuNDVDOC43OTA5OCA5LjcyOTk5IDkuNDIwOTggNy45Mzk5OSA4LjcxMDk4IDYuNDQ5OTlDNy45OTA5OCA0Ljk1OTk5IDYuMjAwOTggNC4zMjk5OSA0LjcwMDk4IDUuMDQ5OTlDMy4yMTA5OCA1Ljc1OTk5IDIuNTgwOTggNy41NDk5OSAzLjMwMDk4IDkuMDQ5OTlDNC4wMTA5OCAxMC41NCA1LjgwMDk4IDExLjE3IDcuMzAwOTggMTAuNDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatFlatAngled = createIcon('AirlineSeatFlatAngled', [
  [
    'path',
    {
      d: 'M22.251 14.54L21.561 16.43L9.20098 11.96L11.281 6.29999L19.841 9.38999C21.941 10.15 23.021 12.45 22.251 14.54ZM1.50098 12.39L8.00098 14.73V19.25H16.001V17.62L20.521 19.25L21.211 17.36L2.19098 10.5L1.50098 12.39ZM7.30098 10.45C8.79098 9.72999 9.42098 7.93999 8.71098 6.44999C7.99098 4.95999 6.20098 4.32999 4.70098 5.04999C3.21098 5.75999 2.58098 7.54999 3.30098 9.04999C4.01098 10.54 5.80098 11.17 7.30098 10.45Z',
      key: 'gb7lt5',
    },
  ],
]);

export default AirlineSeatFlatAngled;
